import CircularProgress from "@mui/material/CircularProgress";
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Fonts, FontColors } from "theme/fontConfig";

const StripeCardBox = forwardRef(({onSaveCard,loading, setLoading,saveCard},ref) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);

  useImperativeHandle(ref, () => ({
    async handleGetToken() {
      setLoading(true);
      const { error, token } = await stripe.createToken(elements.getElement(CardElement))
      if (error) {
        setError(error.message);
        setLoading(false);
        return null;
      } else {
        setError(null);
        return token?.id
      }
    },
  }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); 
    const { error, token } = await stripe.createToken(elements.getElement(CardElement))
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setError(null);
      onSaveCard(token?.id)
    }
  };
  const cardElementOptions = {
    style: {
      base: {
        fontSize: `${Fonts.GeneralLargeBodyFont.fontSize}px`,
        color: FontColors.Slate424770,
        '::placeholder': {
          color: FontColors.SlateAAB7C4,
        },

      },
      invalid: {
        color: FontColors.Red9E2146,
      },
    },

  };
  

  return (
    <div  className="stripe-add-card">
      <div className="stripe-add-card__container">
        <div className="stripe-add-card__box">
          <CardElement options={cardElementOptions} />
        </div>
        {error && <div style={{ color: FontColors.Red }}>{error}</div>}
      </div>
      {saveCard && (
        <div className="stripe-add-card__action" onClick={handleSubmit}>
          <button type="button" disabled={!stripe | loading} className="primary-button">
            {loading ? (
              <CircularProgress
              size={22}
              style={{
                color: FontColors.White,
              }}
            />
            ) : "Add Card"}
          </button>
        </div>
      )}
    </div>
  );
});

export default StripeCardBox;